export default class SearchBar {

    constructor() {
        if (this.searchInputFields = document.querySelectorAll(".searchbar")) {
            this._checkInputLengthOnPageLoad();
            this._checkInputLength()
        }
    }

    _checkInputLengthOnPageLoad() {
        for (let i = 0; i < this.searchInputFields.length; i += 1) {
            const searchinput = this.searchInputFields[i].querySelector('input[type="search"]')
            const searchButton = searchinput.nextElementSibling
            if (searchinput.value.length === 0) {
                searchButton.disabled = true
            }

            else {
                searchButton.disabled = false
            }
        }
    }

    _checkInputLength() {
        for (let i = 0; i < this.searchInputFields.length; i += 1) {
            this.searchInputFields[i].addEventListener('submit', function (e) {
                const searchinput = this.querySelector('input[type="search"]')
                if (searchinput.value.length === 0) {
                    e.preventDefault()
                }
            })

            this.searchInputFields[i].addEventListener('keyup', function () {
                const searchinput = this.querySelector('input[type="search"]')
                const searchButton = searchinput.nextElementSibling
                if (searchinput.value.length === 0) {
                    searchButton.disabled = true
                }

                else {
                    searchButton.disabled = false
                }
            })
        }
    }
}